export const documentElement = window.document.documentElement;
export const head = window.document.head;
export const getElementsByTagName = window.document.getElementsByTagName;
export const createElement = window.document.createElement;
export const body = window.document.body;
export const getHeight = () => {
    return Math.max(document.body.scrollHeight, document.body.offsetHeight);
};
export const referrer = () => window.document.referrer;
export const url = () => window.document.URL;
